export default __webpack_public_path__ + "static/media/gallery18.7e601b91.jpg";